// extracted by mini-css-extract-plugin
export var currentStep = "_gp-2";
export var nodeCard = "_gp-0";
export var pathHighlighted = "_gp-1";